import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BaseDto } from '@models/base/baseDto.model';
import { CreateKeyValueRequest } from '@models/base/createKeyValueRequest.model';
import { UpdateKeyValueRequest } from '@models/base/updateKeyValueRequest.model';
import { CreateBonificacionRequest } from '@models/bonificaciones/createBonificacionRequest.model';
import { TipoBonificacionDto } from '@models/bonificaciones/tipoBonificacionDto.model';
import { CreateTipoBonificacionRequest } from '@models/bonificaciones/createTipoBonificacionRequest.model';
import { UpdateTipoBonificacionRequest } from '@models/bonificaciones/updateTipoBonificacionRequest.model';
import { isFalsy } from 'utility-types';

@Injectable({
  providedIn: 'root'
})
export class TiposBonificacionService {

  private id!: number;

  set setId(id:number) {
    this.id = id;
  }

  get getId() {
    return this.id;
  }

  constructor(
    private http: HttpClient
  ) { }

  create(createRequest:CreateTipoBonificacionRequest):Observable<any>
  {
    return  this.http.post<any>("/api/TipoBonificacion/Create",createRequest);
  }

  update(updateRequest:UpdateTipoBonificacionRequest):Observable<any>
  {
    return  this.http.put<any>("/api/TipoBonificacion/Update",updateRequest);
  }

  getAll():Observable<TipoBonificacionDto[]>
  {
    return  this.http.get<TipoBonificacionDto[]>("/api/TipoBonificacion/GetAll");
  }

  getById(id:number):Observable<TipoBonificacionDto>
  {
    return  this.http.get<TipoBonificacionDto>("/api/TipoBonificacion/GetById?id="+id);
  }

  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/TipoBonificacion/Delete?id=" + id);
    else
      return of(null)
  }
}
